module.exports = __webpack_public_path__ + "static/media/top-view-nutritional-counter-app-composition.c448ace2.jpg";